import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "../../hooks/useAuth";
import CustomGoogleSignIn from "./CustomGoogleSignIn";
import "bootstrap/dist/css/bootstrap.min.css";
import useSystemLogo from "../../hooks/useSystemLogo";

const Login = () => {
  const { t, i18n } = useTranslation();
  const { auth } = useAuth();
  const systemLogo = useSystemLogo();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || { pathname: "/Home" };

  useEffect(() => {
    if (auth?.accessToken) {
      navigate(from, { replace: true });
    }
  }, [auth?.accessToken, navigate, from]);

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={{ 
        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        position: "relative"
      }}
    >
      <div style={{ position: "absolute", top: "20px", right: "20px", display: "flex", alignItems: "center", gap: "6px" }}>
        {['lng1', 'lng2', 'lng3']
        .map(slot => {
            const cfg = window.__UMS_THEME__?.languages?.[slot];
            return cfg ? { code: slot, label: cfg.name } : null;
        })
        .filter(Boolean)
        .map((lang, idx) => (
          <React.Fragment key={lang.code}>
            {idx > 0 && <span style={{ color: "#adb5bd", fontSize: "0.85rem" }}>|</span>}
            <button
              type="button"
              onClick={() => { i18n.changeLanguage(lang.code); sessionStorage.setItem("umsLoginLangOverride", lang.code); }}
              style={{
                background: "none",
                border: "none",
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: "0.85rem",
                color: i18n.language === lang.code ? "var(--brand-red)" : "#6c757d",
                fontWeight: i18n.language === lang.code ? 600 : 400,
                textDecoration: i18n.language === lang.code ? "underline" : "none",
              }}
            >
              {lang.label}
            </button>
          </React.Fragment>
        ))}
      </div>
      <div className="card shadow-lg border-0 p-5" style={{
        width: "100%",
        maxWidth: "420px",
        borderRadius: "12px"
      }}>
        <div className="text-center mb-4">
          <div className="mb-3">
            <img
              src={systemLogo}
              alt="Logo"
              style={{ height: "50px" }}
            />
          </div>
          <h3 className="mt-3 fw-semibold" style={{ fontSize: "1.5rem", color: "var(--brand-red)" }}>
            {t("loginTitle") || "Staff Portal"}
          </h3>
          <p className="text-muted mt-2" style={{ fontSize: "0.9rem" }}>
            {t("loginSubtitle") || "Sign in to access your account"}
          </p>
        </div>
        <div className="mb-3">
          <CustomGoogleSignIn />
        </div>
        <div className="text-center mt-4 pt-3 border-top">
          <small className="text-muted" style={{ fontSize: "0.85rem" }}>
            <i className="bi bi-shield-lock-fill me-2" style={{ color: "var(--brand-red)" }}></i>
            Secure Login
          </small>
        </div>
        <footer className="text-center mt-3">
          <small className="text-muted" style={{ fontSize: "0.8rem" }}>
            &copy; 2024–{new Date().getFullYear()} {t("footerCopyRightMessage") || "All rights reserved"}
          </small>
        </footer>

      </div>
    </div>
  );
};

export default Login;
